import React from "react";
import { Delegator } from "types";
import { AccountListModal } from "@/components/Common/AccountListModal";
import { useAccount } from "@/hooks/useAccount";
import { reloadAppWithDelegator } from "@/hooks/useSwitchDelegator";
import { LoginSkeleton } from "@/pages/LoginSkeleton";

export const AccountSelector = () => {
    const { data } = useAccount();
    const { user = null, delegators = [], shouldRemember = false } = data ?? {};

    const handleSelect = (delegator: Delegator) => {
        if (user) {
            reloadAppWithDelegator(user, delegator, shouldRemember);
        }
    };

    if (!data) {
        return null;
    }

    return (
        <>
            <LoginSkeleton />
            <AccountListModal
                isOpen
                title="Select Account"
                delegators={delegators}
                shouldCloseOnOutsideClick={false}
                onSelect={handleSelect}
            />
        </>
    );
};
